import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import MonthlyFollowUpDashboard from './MonthlyFollowUpDashboard';

const MonthlyProgressDashboardScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);

  return (
    <PageContent title={t('salesPerformance:MonthlyFollowUp')}>
      <MonthlyFollowUpDashboard />
    </PageContent>
  )
}

export default MonthlyProgressDashboardScreen;